import { PermissionModels } from '@share-models';
import { PanicNavigationModels } from '../models/navigation.model';
import { routerSegments } from './routes';

function resolve(
  item: PanicNavigationModels.Item,
): PanicNavigationModels.ResolvedItem {
  return { ...item, path: `/${routerSegments[item.segment]}` };
}

const ITEMS: readonly PanicNavigationModels.Item[] = [
  {
    segment: 'home',
    icon: 'ui-icon-users',
    labelKey: 'MEMBERS.TITLE',
    bottomBar: true,
    permissions: [
      PermissionModels.Permissions.PanicMembersManagement,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'groups',
    icon: 'ui-icon-menu-folder-sidebar',
    labelKey: 'GROUPS.TITLE',
    bottomBar: true,
    permissions: [
      PermissionModels.Permissions.PanicGroupsManagement,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'httpRequests',
    icon: 'ui-icon-webhook',
    labelKey: 'HTTP_REQUESTS.TITLE',
    bottomBar: true,
    permissions: [
      PermissionModels.Permissions.PanicHttpRequestManagement,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'polygons',
    icon: 'ui-icon-zone-region',
    labelKey: 'POLYGONS.TITLE',
    bottomBar: false,
    permissions: [PermissionModels.Permissions.PanicAppManagement],
  },
  {
    segment: 'systemConfiguration',
    icon: 'ui-icon-settings',
    labelKey: 'SYSTEM_CONFIGURATION.TITLE',
    bottomBar: false,
    permissions: [
      PermissionModels.Permissions.PanicSystemConfiguration,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'contactsActivityLog',
    icon: 'ui-icon-history',
    labelKey: 'ACTIVITY_LOG.TITLE',
    bottomBar: true,
    permissions: [
      PermissionModels.Permissions.PanicContactActivity,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'userActivityLog',
    icon: 'ui-icon-user-sidebar',
    labelKey: 'USER_ACTIVITY_LOG.TITLE',
    bottomBar: false,
    permissions: [
      PermissionModels.Permissions.PanicUserActivity,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
  {
    segment: 'manualEvents',
    icon: 'ui-icon-controls-event-sidebar',
    labelKey: 'EVENT_TYPES.TITLE',
    bottomBar: false,
    permissions: [
      PermissionModels.Permissions.PanicManualEventsManagement,
      PermissionModels.Permissions.PanicAppManagement,
    ],
  },
];

const USER_ITEMS: readonly PanicNavigationModels.Item[] = [
  {
    segment: 'accountDetails',
    icon: 'ui-icon-user',
    labelKey: 'USER_MENU.ACCOUNT_DETAILS_TITLE',
    bottomBar: false,
  },
];

export const NAVIGATION_ITEMS: readonly PanicNavigationModels.ResolvedItem[] =
  ITEMS.map(resolve);

export const USER_NAVIGATION_ITEMS: readonly PanicNavigationModels.ResolvedItem[] =
  USER_ITEMS.map(resolve);

export const BOTTOM_BAR_ITEMS: readonly PanicNavigationModels.ResolvedItem[] =
  NAVIGATION_ITEMS.filter((item) => item.bottomBar);
